// extracted by mini-css-extract-plugin
export default {"provider-btn":"provider-btn--2qp4b","twitch":"twitch--2Y5BT","youtube":"youtube--3uIO8","facebook":"facebook--14zie","trovo":"trovo--3tyW0","kick":"kick--3fJtq","auth-providers-panel":"auth-providers-panel--3eFeE","google":"google--2LUPa"};
    if(module.hot) {
      // 1747648152559
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  